import {IWithSummaryModel} from '../../../../common/permission/api/entity/iWithSummary.model';
import {DocumentTemplateSummaryModel} from './documentTemplateSummary.model';
import {DocumentSummaryModel} from '../../../common/api/model/documentSummary.model';
import {DocumentTemplatePlaceholderModel} from "./documentTemplatePlaceholder.model";

export class DocumentTemplateModel implements IWithSummaryModel<DocumentTemplateSummaryModel> {
    summary: DocumentTemplateSummaryModel;
    document: DocumentSummaryModel;
    placeHolders: DocumentTemplatePlaceholderModel[] = [];
}
